import React, { useEffect } from 'react';
import styles from './NewTopic.module.scss';
import Input from 'component/atom/forms/input/input/Input';
import { useFormik } from 'formik';
import * as Yup from 'yup';
import Modal from 'component/hoc/modal/Modal';
import { usePost } from 'hooks/usePost';
import { topics } from 'hooks/endpoints';
import { useParams } from 'react-router-dom';
const Form = ({ formik }) => {
  return (
    <form
      autoComplete='off'
      onSubmit={formik.handleSubmit}
      className={styles.formCont}
    >
      <Input
        label='Name'
        placeholder='e.g Admission'
        name='topicName'
        value={formik.values.topicName}
        onChange={formik.handleChange}
        onBlur={formik.handleBlur}
        error={formik.errors.topicName}
        touched={formik.touched.topicName}
        inputContainerClassName={styles['input-container']}
      />
    </form>
  );
};

const NewTopic = ({ isOpen, onClose, refetch, item }) => {
  const { id } = useParams();

  const { mutate: addTopic, isPending } = usePost({
    onSuccessToast: item
      ? 'Topic has been edited successfully'
      : 'Topic is added successfully',
    toastType: item ? 'update' : 'add',
  });
  const validationSchema = Yup.object({
    topicName: Yup.string().required('Topic Name is Required'),
  });

  const formik = useFormik({
    initialValues: {
      topicName: item?.topicText || '',
    },
    validationSchema,
    onSubmit: (values, { resetForm }) => {
      addTopic(
        {
          data: {
            ...values,
            botId: id,
            topicId: item
              ? item?.topicId
              : '00000000-0000-0000-0000-000000000000',
          },
          url: topics.saveTopic,
        },
        {
          onSuccess: () => {
            refetch();
            resetForm();
            onClose();
          },
        }
      );
    },
    enableReinitialize: true,
  });
  useEffect(() => {
    if (!isOpen) {
      formik.resetForm();
    }
  }, [isOpen]);
  return (
    <div>
      <Modal
        title={item ? 'Edit Topic' : 'Add Topic'}
        isOpen={isOpen}
        onClose={onClose}
        modalContent={{
          component: <Form formik={formik} />,
        }}
        onSubmit={formik.handleSubmit}
        buttonType='submit'
        onSubmitstyles={{
          onSubmit: {
            label: 'Save',
            type: 'save',
            opicBAckground: true,
          },
        }}
        isLoading={isPending}
        classname={styles['modal']}
      />
    </div>
  );
};

export default NewTopic;
